import React, { useEffect, useState, useCallback } from "react";
import { useIntl } from 'react-intl';
import { Line } from 'react-chartjs-2';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import "../../styles.scss";

const Graph = ({ data: propData }) => {
  const [chartData, setChartData] = useState({});
  const { formatMessage } = useIntl();

  const parseData = useCallback((name) => {
    const arrayOfDates = Object.keys(propData);
    const tmp = arrayOfDates.sort((a, b) => new Date(a) - new Date(b));

    return tmp.map(d => propData[d][name] || 0)
  }, [propData]);

  useEffect(() => {
    setChartData({
      labels: Object.keys(propData)
        .sort((a, b) => new Date(a) - new Date(b))
        .map(date => format(new Date(date), 'MMM yyyy', {
          locale: ptBR
        })),
      datasets: [
        {
          label: formatMessage({ id: 'usuarios-unicos' }),
          data: parseData('usuarios_unicos'),
          borderColor: ['#43D954'],
          borderWidth: 2,
          fill: false
        },
        {
          label: formatMessage({ id: 'usuarios-consultas' }),
          data: parseData('usuarios_com_consultas'),
          borderColor: ['#d72b72'],
          borderWidth: 2,
          fill: false
        },
        {
          label: formatMessage({ id: 'consultas-normais' }),
          data: parseData('consultas_normais'),
          borderColor: ['#edda57'],
          borderWidth: 2,
          fill: false
        },
        {
          label: formatMessage({ id: 'consultas-empresariais' }),
          data: parseData('consultas_empresariais'),
          borderColor: ['#5e0fca'],
          borderWidth: 2,
          fill: false
        }
      ]
    })
  }, [propData, formatMessage, parseData]);

  return (
    <Line
      width={1200}
      height={300}
      data={chartData}
      options={{
        elements: {
          line: {
            tension: 0,
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        responsive: true,
        legend: {
          display: true,
        },
      }}
    />
  );
};

export default Graph;
